import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-criar-beneficios',
  templateUrl: './criar-beneficios.component.html',
  styleUrls: ['./criar-beneficios.component.css']
})
export class CriarBeneficiosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
